import { gql } from "@apollo/client";

export const CLOSE_COMPANION_SESSION = gql`
  mutation closeCompanionSession($companionSessionUuid: String!) {
    closeCompanionSession(
      companionSessionUuid: $companionSessionUuid
    ) {
      ok
    }
  }
`;
